module.exports = __webpack_public_path__ + "static/media/Matafuegos03.09d0a4ef.jpg";